import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { Icons } from '../icons';

export default function EmptyState({ title = 'Nothing here yet', message = 'There are no records to display.', action, onAction }) {
  return (
    <div className="empty-state">
      <SafeIcon icon={Icons.Inbox} />
      <h3>{title}</h3>
      <p>{message}</p>
      {action && <button className="primary-button" onClick={onAction}><SafeIcon icon={Icons.Plus} /> {action}</button>}
    </div>
  );
}